import React from 'react';
import { Card, CardBody } from 'reactstrap';
import moment from 'moment';
import Lucree from '~/assets/img/lucreeNegativo.svg';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';

export default function Filipeta(props) {
	const { dados } = props;
	return (
		<Card
			style={{
				backgroundColor: color.yellowLight,
				boxShadow: 'unset',
			}}
			className="w-100">
			<CardBody>
				<div
					className="d-flex align-items-center mb-4 pb-2"
					style={{ borderBottom: `1px solid ${color.gray}` }}>
					<img
						src={Lucree}
						width="50"
						alt="lucree"
						className="mr-3"
					/>
					<Text size="big">LUCREE</Text>
				</div>
				<div className="d-flex align-items-center mb-2">
					<Text size="default">Recebedor:</Text>
				</div>
				<div className="d-flex align-items-center mb-2">
					<Text size="default">{dados.nomeUser}</Text>
				</div>
				<div
					className="d-flex justify-content-between mb-4 pb-2"
					style={{ borderBottom: `1px solid ${color.gray}` }}>
					{/* <Text size="small">{dados.billing_street}, {dados.delivery_city} - {dados.billing_state}</Text> */}
					<Text size="small">
						CPF/CNPJ
						{dados.documentoUser}
					</Text>
				</div>
				<div className="d-flex align-items-center mb-2">
					<Text size="default">{dados.modalidade}</Text>
				</div>
				<div className="d-flex justify-content-between mb-2">
					<Text size="default">{dados.numeroCartao}</Text>
					<Text size="default">{dados.valor}</Text>
				</div>
				<div
					className="d-flex align-items-center mb-4 pb-2"
					style={{ borderBottom: `1px solid ${color.gray}` }}>
					<Text size="default">{dados.nome}</Text>
				</div>
				<div className="d-flex align-items-center mb-2">
					<Text size="default">Dados da Transação:</Text>
				</div>
				<div className="d-flex justify-content-between mb-2">
					<Text size="default">
						{'ID da Venda: '}
						<span style={{ wordBreak: 'break-word' }}>
							{dados.idVenda}
						</span>
					</Text>
				</div>
				<div className="d-flex justify-content-between mb-2">
					<Text size="default">{`AUTORIZAÇÃO: ${dados.autorizacao}`}</Text>
				</div>

				<div className="d-flex justify-content-between mb-2">
					<Text size="default">
						{`Data de Geração do Link: ${moment(dados.data).format(
							'DD/MM/YYYY'
						)}`}
					</Text>
					<Text size="default">
						{moment(dados.data).subtract(3, 'hours').format('HH:mm')}
					</Text>
				</div>

				<div
					className="d-flex justify-content-between mb-4 pb-2"
					style={{ borderBottom: `1px solid ${color.gray}` }}>
					<Text size="default">
						{`Data da Autorização de pagamento: ${moment(
							dados.dataPag
						).format('DD/MM/YYYY')}`}
					</Text>
					<Text size="default">
						{moment(dados.dataPag).subtract(3, 'hours').format('HH:mm')}
					</Text>
				</div>

				<div
					className="d-flex justify-content-between mb-2 pb-2"
					style={{ borderBottom: `1px solid ${color.gray}` }}>
					<Text size="default">
						{`Pagamento recorrente: ${dados.recorrente ? 'Sim' : 'Não'
							}`}
					</Text>
					{dados.recorrente && (
						<Text size="default">
							{`Frequência da recorrência: ${dados.frequenciaRecorrencia}`}
						</Text>
					)}
				</div>
			</CardBody>
		</Card>
	);
}
